import React, { lazy } from "react";
import Loadable from "../components/Loadable";
// import { authRoles } from "../auth/authRoles";
import { routeCheck } from "app/data/roles";

const Services = Loadable(
  lazy(() => import("app/views/register/service/ServiceList"))
);
const Institutions = Loadable(
  lazy(() => import("app/views/register/institution/InstitutionList"))
);
const Divisions = Loadable(
  lazy(() => import("app/views/register/division/DivisionList"))
);
const Departments = Loadable(
  lazy(() => import("app/views/register/department/DepartmentList"))
);
const InstitutionRequest = Loadable(
  lazy(
    () => import("app/views/register/institutionRequest/InstitutionRequestList")
  )
);
const Holidays = Loadable(
  lazy(() => import("app/views/register/holiday/HolidayList"))
);
const Announcement = Loadable(
  lazy(() => import("app/views/register/announcement/AnnouncementList"))
);

const registerPaths = routeCheck(
  [
    { path: "/register/services", element: <Services /> },
    { path: "/register/institutions", element: <Institutions /> },
    { path: "/register/divisions", element: <Divisions /> },
    { path: "/register/departments", element: <Departments /> },
    { path: "/register/InstitutionsRequest", element: <InstitutionRequest /> },
    { path: "/register/holidays", element: <Holidays /> },
    { path: "/register/announcement", element: <Announcement /> },
  ],
  false
);

export default registerPaths;
